<template>
  <div class="h-full py-10px">
    <div class="flex justify-between mb-10px">
      <el-input placeholder="请输入关键字" v-model="keyWords" class="w-190px"></el-input>
      <div>
        <el-button class="mr-5px" @click="getList">搜索</el-button>
        <el-button @click="openDetail">新增</el-button>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      height="calc(100% - 80px)"
      class="mb-10px"
      highlight-current-row
      @row-click="clickRow"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        v-for="col in cloumns"
        show-overflow-tooltip
        :key="col.prop"
        :prop="col.prop"
        :width="col.width"
        :label="col.label"
      >
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="{ row }">
          <div class="flex justify-between">
            <i
              class="el-icon-edit-outline mr-5px cursor-pointer text-[#02dc0b]"
              @click="openDetail(row)"
            ></i>
            <i class="el-icon-delete cursor-pointer text-[#02dc0b]" @click="deleteItem(row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-center">
      <el-pagination
        class="pr-6px float-right flex"
        background
        size="mini"
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        layout="slot, prev, pager, next"
        :page-size.sync="page.pageSize"
        :total="page.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DiyCodeService from '../../../service/DiyCodeService.js'

export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {},
    },
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cloumns: [
        {
          prop: 'Name',
          label: '标记名称',
        },
        {
          prop: 'UserName',
          label: '创建人',
        },
      ],
      keyWords: '',
      loading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      currentId: null,
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        if (val?.mode === 'close') {
          this.setMarkerVisible(true)
        }
        this.getList()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clickRow(row) {
      const pos = [row.XAxial, row.YAxial, row.ZAxial]
      this.player.Native.Camera.moveToPos(pos, 0, 50, 2)
    },
    deleteItem(row) {
      this.$confirm('删除后将无法恢复, 确认删除', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      }).then(async () => {
        const [err, res] = await DiyCodeService.getPipesData({
          FormEngineKey: 'diy_3DCoordinationManagement_Descripts',
          _Where: [
            {
              Name: 'FlagId',
              Value: row.Id,
              Type: '=',
            },
          ],
        })
        if (!err && res.Code === 1) {
          await DiyCodeService.delFormData({
            FormEngineKey: 'diy_3DCoordinationManagement',
            Id: row.Id,
          })
          if (res.Data && res.Data.length !== 0) {
            const data = res.Data.map((o) => {
              return {
                FormEngineKey: 'diy_3DCoordinationManagement_Descripts',
                Id: o.Id,
              }
            })
            const [er, re] = await DiyCodeService.DelDiyTableRowBatch(data)
            if (!er && re.Code === 1) {
              this.$message.success('删除成功！')
              this.getList()
            }
          } else {
            this.$message.success('删除成功！')
            this.getList()
          }
          const event = new CustomEvent('useLabelFunction', {
            detail: {
              code: 'MarkerList',
              function: 'delete',
              param: row.Id,
            },
          })
          window.dispatchEvent(event)
          console.log(this.currentId === row.Id, 'gbo')
          setTimeout(() => {
            if (this.currentId === row.Id) {
              this.$emit('closeComponent', {
                code: 'MarkersManagementDetails',
                origin: 'business',
              })
            }
          }, 500)
        }
      })
    },
    async getList() {
      const param = {
        // FormEngineKey: 'diy_3DCoordinationManagement',
        ModuleEngineKey: 'ad3ef519-f8e7-498b-8f1a-a47f0e60cd29',
        _PageSize: this.page.pageSize,
        _PageIndex: this.page.pageNo,
        _OrderBy: 'CreateTime',
        _OrderByType: 'desc',
      }
      if (this.keyWords) {
        param._Where = [
          {
            Name: 'Name',
            Type: 'Like',
            Value: this.keyWords,
          },
        ]
      }
      const [err, res] = await DiyCodeService.getPipesData(param)
      if (!err && res.Code === 1) {
        this.tableData = res.Data
        this.page.total = res.DataCount
      }
    },
    openDetail(val) {
      this.currentId = val.Id
      this.setMarkerVisible(false)
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'MarkersManagementDetails',
            origin: 'business',
            name: '三维标记协同',
          },
          type: 'business',
          position: 'right',
          props: {
            ...val,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    switchMarker(show) {
      const event = new CustomEvent('setLabelChecked', {
        detail: {
          code: 'MarkerList',
          checked: show,
        },
      })
      window.dispatchEvent(event)
    },
    setMarkerVisible(val) {
      const event = new CustomEvent('useLabelFunction', {
        detail: {
          code: 'MarkerList',
          function: 'setVisible',
          param: val,
        },
      })
      window.dispatchEvent(event)
    },
  },
  mounted() {
    this.getList()
    this.switchMarker(true)
  },
  beforeDestroy() {
    this.switchMarker(false)
  },
}
</script>

<style lang="scss" scoped>
.el-button--default {
  color: #fff !important;
}
</style>
